export default __webpack_public_path__ + "static/media/11.594f6ad1.webp";